export const itemsPerPage = 10;

export const actionTypeMapOld = {
    shortlistNewEvent: 1,
    addToShortlistCluster: 2,
    publishNewEvent: 3,
    addToPublishCluster: 4,
    shortlistAsHealthInfo: 5,
    rejectFakeSource: 6,
    rejectOldNews: 7,
    rejectIrrelevant: 8,
    rejectPublished: 9,
    rejectInternationalEvent: 10,
    rejectLowerCaseCount:11
}

export const actionTypeMap = {
    shortlist: {
        key: "shortlist",
        name: "Shortlisted",
        value: 1
    },
    remove: {
        key: "remove",
        name: "Remove"
    },
    reject: {
        types: {
            rejectFakeSource: {
                name: "Unreliable Source/News",
                value: 6
            },
            rejectOldNews: {
                name: "Old Event",
                value: 7
            },
            rejectIrrelevant: {
                name: "Irrelevant Event",
                value: 8
            },
            rejectPublished: {
                name: "Already Published Event",
                value: 9
            },
            rejectInternationalEvent: {
                name: "International event",
                value: 10
            },
            rejectLowerCaseCount: {
                name: "Lower Case Count",
                value: 11
            },
        },
        key: "reject",
        name: "Rejected",
    },
    saveAsHealthInfo: {
        key: "saveAsHealthInfo",
        name: "Saved Health Info",
        value: 5
    },
    publish: {
        key: "publish",
        name: "Published",
        value: 3
    },
    republish: {
        key: "republish",
        name: "Re-published",
        value: 3
    },
}
